export default "__VITE_ASSET__ColC1FTV__"